import {AnyAction, Dispatch} from '@modifi/redux'
import {createSelector} from 'reselect'

import {rootSelector} from '../../../../../redux/root-selector'

const ACTION_ADD_BUYER = 'pages/preunderwriting/buyers/ADD'
const ACTION_REMOVE_BUYER = 'pages/preunderwriting/buyers/REMOVE'

type loadingLimits = {
  buyerId: string
  timestamp: number
}

export default (state: loadingLimits[] = [], {type, payload}: AnyAction): loadingLimits[] => {
  switch (type) {
    case ACTION_ADD_BUYER: {
      return [...state, {buyerId: payload?.buyerId, timestamp: new Date().getTime()}]
    }
    case ACTION_REMOVE_BUYER:
      return state.filter(existingBuyerLimit => existingBuyerLimit.buyerId !== payload?.buyerId)
    default:
      return state
  }
}

export const aRemoveLoadingLimitForBuyer =
  (buyerId?: string | null | undefined) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: ACTION_REMOVE_BUYER,
      payload: {buyerId},
    })
  }

export const aAddLoadingLimitForBuyer =
  (buyerId?: string | null | undefined) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: ACTION_ADD_BUYER,
      payload: {buyerId},
    })
  }

export const getLoadingLimitsForBuyers = createSelector(
  rootSelector,
  root => root?.pages?.preUnderwriting?.buyerDetails?.loadingLimits
)
